import MobileCarousel from '../../src/js/mobile-carousel';

export default class TabbedContent {
  constructor() {
    this.$els = document.querySelectorAll('.js-tabbed-content');
    this.$els.forEach(($el) => {
      const $buttons = $el.querySelectorAll('.js-tabbed-content-tab-button');
      const $contents = $el.querySelectorAll('.js-tabbed-content-tab-content');
      const $videosContainer = $el.querySelector('.js-tabbed-content-videos');

      if ($videosContainer) {
        const $videoWrappers = $videosContainer.querySelectorAll('.js-tabbed-content-video-wrapper');
        const mobileCarousel = new MobileCarousel($videosContainer);

        $videoWrappers.forEach(($videoWrapper) => new Video($videoWrapper));
      }

      $buttons.forEach(($button, buttonIndex) => new Tab({
        $buttons,
        $contents,
        buttonIndex,
      }));

    });
  }
}

class Tab {
  constructor(options) {
    this.$buttons = options.$buttons;
    this.$contents = options.$contents;
    this.buttonIndex = options.buttonIndex;
    this.$selectedButton = this.$buttons[this.buttonIndex];
    this.$selectedContent = this.$contents[this.buttonIndex];

    this.activeClass = 'is-active';

    // this.$playButtons = this.$selectedContent.querySelectorAll('.js-tabbed-content-video-button');

    // this.$playButtons.forEach($playButton => {
    //   $playButton.addEventListener('click', this.handlePlayButton.bind(this));
    // });

    this.$selectedButton.addEventListener('click', (e) => this.handleButtonClick(e));
  }

  handleButtonClick(e) {
    e.preventDefault();

    this.$buttons.forEach(($button) => {
      $button.classList.remove(this.activeClass);
    });

    this.$selectedButton.classList.add(this.activeClass);

    this.$contents.forEach(($content, contentIndex) => {
      $content.setAttribute('aria-hidden', 'true');
      $content.classList.remove(this.activeClass);
    });

    this.$selectedContent.classList.add(this.activeClass);
    this.$selectedContent.setAttribute('aria-hidden', 'false');

    const t = setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
      clearTimeout(t);
    }, 0);
  }
}


class Video {
  constructor($el) {
    this.$el = $el;
    this.playingClass = 'is-playing';
    this.$playButton = this.$el.querySelector('.js-tabbed-content-video-button');
    this.$pauseButton = this.$el.querySelector('.js-tabbed-content-video-pause');
    this.$playButton.addEventListener('click', this.handlePlayButton.bind(this));
    this.$pauseButton.addEventListener('click', this.handlePauseButton.bind(this));
  }

  handlePlayButton(e) {
    e.preventDefault();
    e.stopPropagation();

    const $button = e.currentTarget;
    const $placeholderImage = $button.parentElement.querySelector('.js-tabbed-content-placeholder-image');
    const $video = $button.parentElement.querySelector('.js-tabbed-content-video');

    $video.addEventListener("ended", (event) => {
      $placeholderImage.classList.remove(this.playingClass);
      this.$pauseButton.classList.remove(this.playingClass);
      $button.classList.remove(this.playingClass);
    });

    $placeholderImage.classList.add(this.playingClass);
    $button.classList.add(this.playingClass);
    this.$pauseButton.classList.add(this.playingClass);

    $video.play();
  }

  handlePauseButton(e) {
    e.preventDefault();
    e.stopPropagation();

    const $button = e.currentTarget;
    const $placeholderImage = $button.parentElement.querySelector('.js-tabbed-content-placeholder-image');
    const $video = $button.parentElement.querySelector('.js-tabbed-content-video');

    this.$playButton.classList.remove(this.playingClass);
    $placeholderImage.classList.remove(this.playingClass);
    $button.classList.remove(this.playingClass);

    $video.pause();
    $video.currentTime = 0;
    $video.load();
  }
}
